













































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { PopSettingsVO } from '@/model/FormWheel';
import { isEnablePrivacySetting } from '@/utils/experiment';

@Component({
  name: 'EmbeddedPopup'
})
export default class EmbeddedPopup extends Vue {
  @Prop({ required: true }) formData!: PopSettingsVO;

  @Prop({ required: true }) activePageSetting!: string;

  @Prop(String) couponCopyText!: string;

  @Prop(Array)
  countryList!: any;

  selectedCountry = {
    countryAbbreviation: 'US',
    phoneCode: '+1'
  };

  get startOrEnd() {
    // 根据 activePageSetting 返回对应的表单数据
    if (this.activePageSetting === 'start') {
      return this.formData.start || [];
    } else if (this.activePageSetting === 'end') {
      return this.formData.end || [];
    } else if (this.activePageSetting === 'middle') {
      return this.formData.middle || [];
    }

    return this.formData.start || [];
  }

  // 获取嵌入弹窗容器样式
  get embeddedPopupStyle() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-show',
      middle: 'cartx-b-show__middle',
      end: 'cartx-b-show__end'
    };
    const styleKey = styleKeyMap[this.activePageSetting || 'start'];
    console.log('234234', styleKey, this.formData.styles.styleMap, this.formData.styles.styleMap[styleKey]);
    return {
      background: this.formData.styles.styleMap[styleKey]?.background || ''
    };
  }

  // 获取当前页面的标题文本
  get currentTitleText() {
    const titleMap: { [key: string]: string } = {
      start: this.formData.texts.topTitle || '',
      middle: this.formData.texts.middleTopTitle || '',
      end: this.formData.texts.endTopTitle || ''
    };
    return titleMap[this.activePageSetting] || '';
  }

  // 获取当前页面的标题样式键名
  get currentTitleStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-title',
      middle: 'cartx-b-title__middle',
      end: 'cartx-b-title-end'
    };
    return styleKeyMap[this.activePageSetting] || 'cartx-b-title';
  }

  // 获取当前页面的标题样式对象
  get currentTitleStyle() {
    const styleKey = this.currentTitleStyleKey;
    const styleMap = this.formData.styles.styleMap[styleKey] || {};

    return {
      color: styleMap.color,
      fontFamily: styleMap['font-family'],
      fontSize: styleMap['font-size'],
      textAlign: styleMap['text-align']
    };
  }

  // 获取当前页面的副标题文本
  get currentSubtitleText() {
    const textMap: { [key: string]: string } = {
      start: this.formData.texts.topSubTitle || '',
      middle: this.formData.texts.middleTopSubTitle || '',
      end: this.formData.texts.endTopSubTitle || ''
    };
    return textMap[this.activePageSetting] || '';
  }

  // 获取当前页面的副标题样式键名
  get currentSubtitleStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-subtitle',
      middle: 'cartx-b-subtitle__middle',
      end: 'cartx-b-subtitle-end'
    };
    return styleKeyMap[this.activePageSetting] || 'cartx-b-subtitle';
  }

  // 获取当前页面的副标题样式对象
  get currentSubtitleStyle() {
    const styleKey = this.currentSubtitleStyleKey;
    const styleMap = this.formData.styles.styleMap[styleKey] || {};

    return {
      color: styleMap.color,
      fontFamily: styleMap['font-family'],
      fontSize: styleMap['font-size'],
      textAlign: styleMap['text-align']
    };
  }

  // 获取当前页面的按钮样式键名
  get currentButtonStyleKey() {
    const styleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-button',
      middle: 'cartx-b-button__middle',
      end: 'cartx-b-button-end'
    };
    return styleKeyMap[this.activePageSetting] || 'cartx-b-button';
  }

  // 获取当前页面的按钮链接
  get currentButtonUrl() {
    if (this.activePageSetting === 'start') {
      return this.formData.rules.buttonAction === 'link'
        ? this.defineUrl(this.formData.rules.openUrl)
        : 'javascript:void(0)';
    } else if (this.activePageSetting === 'middle') {
      // middle 页面的按钮逻辑，如果有 middleButtonAction 则使用，否则使用 start 的逻辑
      const middleButtonAction = (this.formData.rules as any).middleButtonAction || this.formData.rules.buttonAction;
      const middleOpenUrl = (this.formData.rules as any).middleOpenUrl || this.formData.rules.openUrl;
      return middleButtonAction === 'link' ? this.defineUrl(middleOpenUrl) : 'javascript:void(0)';
    } else {
      return this.formData.rules.endButtonAction === 'link'
        ? this.defineUrl(this.formData.rules.endOpenUrl)
        : 'javascript:void(0)';
    }
  }

  // 获取当前页面的按钮文本
  get currentButtonText() {
    if (this.activePageSetting === 'start') {
      return this.formData.texts.mainButton;
    } else if (this.activePageSetting === 'middle') {
      return (this.formData.texts as any).middleMainButton || this.formData.texts.mainButton;
    } else {
      // end 页面，暂时不处理 subscribeStatus，因为 embeddedPopupNew 可能不需要
      return this.formData.texts.endMainButton;
    }
  }

  // 获取当前页面的按钮样式对象
  get currentButtonStyle() {
    const buttonStyleKey = this.currentButtonStyleKey;
    const buttonStyleMap = this.formData.styles.styleMap[buttonStyleKey] || {};

    // 获取 show 下的按钮样式（优先级更高）
    const showButtonStyleKeyMap: { [key: string]: string } = {
      start: 'cartx-b-show .cartx-b-button',
      middle: 'cartx-b-show .cartx-b-button__middle',
      end: 'cartx-b-show .cartx-b-button-end'
    };
    const showButtonStyleKey = showButtonStyleKeyMap[this.activePageSetting] || 'cartx-b-show .cartx-b-button';
    const showButtonStyleMap = this.formData.styles.styleMap[showButtonStyleKey] || {};

    return {
      color: buttonStyleMap.color,
      fontFamily: buttonStyleMap['font-family'],
      background: showButtonStyleMap.background || buttonStyleMap.background,
      borderStyle: buttonStyleMap['border-style'],
      borderColor: buttonStyleMap['border-color'],
      borderRadius: buttonStyleMap['border-radius']
    };
  }

  get currentCouponCode() {
    if (this.formData.discountType === 'dongtai' || !!this.formData.discount) {
      return '动态显示折扣码';
    }
    const couponCode = this.formData.rules.couponCode || 'coupon code';
    return couponCode;
  }

  get currentCouponCopy() {
    return this.couponCopyText || 'Copy';
  }

  get enablePrivacySetting() {
    return isEnablePrivacySetting();
  }

  mounted() {
    // console.log(this.formData);
  }

  @Watch('formData', { deep: true })
  onFormDataChange(newVal: PopSettingsVO) {
    // console.log(newVal);
  }

  changeCountryCode(v) {
    this.selectedCountry.phoneCode = v.phoneCode;
    this.selectedCountry.countryAbbreviation = v.countryAbbreviation;
  }

  // 获取当前页面隐私文案颜色（按页面隔离）
  get currentPrivacyColor() {
    const styleMap = this.formData.styles.styleMap;
    if (this.activePageSetting === 'middle') {
      return styleMap['cartx-b-privacy__middle']?.['color'];
    }
    return styleMap['cartx-b-privacy']?.['color'];
  }

  // 获取当前页面的输入框类型
  get currentInputType() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputType || rules.inputType;
    }
    return rules.inputType;
  }

  // 获取当前页面的输入框边框样式
  get currentInputBorderStyle() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBorderStyle || rules.inputBorderStyle;
    }
    return rules.inputBorderStyle;
  }

  // 获取当前页面的输入框边框颜色
  get currentInputBorderColor() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBorderColor || rules.inputBorderColor;
    }
    return rules.inputBorderColor;
  }

  // 获取当前页面的输入框圆角
  get currentInputBorderRadius() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBorderRadius || rules.inputBorderRadius;
    }
    return rules.inputBorderRadius;
  }

  // 获取当前页面的输入框背景显示方式
  get currentInputBackgroundShow() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBackgroundShow !== undefined
        ? (rules as any).middleInputBackgroundShow
        : rules.inputBackgroundShow;
    }
    return rules.inputBackgroundShow;
  }

  // 获取当前页面的输入框背景颜色
  get currentInputBackground() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputBackground || rules.inputBackground;
    }
    return rules.inputBackground;
  }

  // 获取当前页面的输入框文字颜色
  get currentInputColor() {
    const rules = this.formData.rules;
    if (this.activePageSetting === 'middle') {
      return (rules as any).middleInputColor || rules.inputColor;
    }
    return rules.inputColor;
  }

  get formStyle() {
    const inputType = this.currentInputType;
    const borderStyle = this.currentInputBorderStyle;
    const borderColor = this.currentInputBorderColor;
    const borderRadius = this.currentInputBorderRadius;
    const backgroundShow = this.currentInputBackgroundShow;
    const background = this.currentInputBackground;
    const inputColor = this.currentInputColor;

    return `
      .cartx-embedded-form .cartx-embedded-form-input {
        border-width: ${inputType === 'bottom' ? '0 0 1px 0' : '1px'} !important;
        border-style: ${borderStyle} !important;
        border-color: ${borderColor} !important;
        border-radius: ${borderRadius} !important;
        background: ${backgroundShow !== 'none' ? background : 'none'} !important;
        color: ${inputColor} !important;
      }
      .cartx-embedded-form input::-webkit-input-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form input:-moz-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form input::-moz-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form input:-ms-input-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      /* 手机号采集表单样式适配 */
      .cartx-embedded-form-input-mobile-number.el-input {
        border-width: ${inputType === 'bottom' ? '0 0 1px 0' : '1px'} !important;
        border-style: ${borderStyle} !important;
        border-color: ${borderColor} !important;
        border-radius: ${borderRadius} !important;
        overflow: hidden;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner {
        color: ${inputColor} !important;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner::-webkit-input-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner:-moz-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner::-moz-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
      .cartx-embedded-form-input-mobile-number .el-input__inner:-ms-input-placeholder {
        color: ${inputColor} !important;
        opacity: .3;
      }
    `;
  }

  defineUrl(url?: string) {
    if (url?.indexOf('https://') == -1 && url?.indexOf('http://') == -1) {
      return 'http://' + url;
    } else {
      return url;
    }
  }
}
